import useUser from '@/hooks/useUser';
import EditSolid from '@simplywallst/ui-core/icons/EditSolid';
import { Button } from '@simplywallst/ui-core/next';

import { ROUTE_PUBLIC_NARRATIVE_EDIT } from '@/constants/routes';
import { usePathname } from '@/hooks/location/usePathname';
import { getPathSafe } from '@/router/utils';

type Props = {
  authorId: string;
  id: string;
};

export const EditNarrative = ({ authorId, id }: Props) => {
  const { data: user, queryStatus } = useUser();
  const pathname = usePathname();

  if (queryStatus === 'pending' || queryStatus === 'error') {
    return null;
  }

  if (!user.loggedIn || user.id !== authorId) {
    return null;
  }

  const narrativeEditPath = getPathSafe({
    type: ROUTE_PUBLIC_NARRATIVE_EDIT,
    payload: {
      id: id,
      query: {
        returnPath: pathname,
      },
    },
  });

  if (!narrativeEditPath) return null;

  return (
    <Button href={narrativeEditPath} size="medium" variant="secondary">
      <EditSolid />
      Edit
    </Button>
  );
};
